(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quick-checkout-card"] && !Shopify.designMode) return;
  try {
    function formatGuardianMoney(cents, format) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, format);
    }

    var value = cents / 100;
    var placeholder = 'amount';
    var moneyPlaceholderPattern = new RegExp('\\{' + '\\{\\s*(\\w+)\\s*\\}' + '\\}');
    var match = format && format.match(moneyPlaceholderPattern);
    if (match) placeholder = match[1];

    function formatWithDelimiters(number, precision, thousands, decimal) {
      var fixed = number.toFixed(precision);
      var parts = fixed.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }

    var formatted;
    if (placeholder === 'amount_no_decimals') {
      formatted = formatWithDelimiters(value, 0, ',', '.');
    } else if (placeholder === 'amount_with_comma_separator') {
      formatted = formatWithDelimiters(value, 2, '.', ',');
    } else if (placeholder === 'amount_no_decimals_with_comma_separator') {
      formatted = formatWithDelimiters(value, 0, '.', ',');
    } else {
      formatted = formatWithDelimiters(value, 2, ',', '.');
    }

    return format ? format.replace(moneyPlaceholderPattern, formatted) : formatted;
  }


  function escapeGuardianText(value) {
    return String(value).replace(/[&<>"]/g, function(character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;'
      }[character];
    });
  }

  function getGuardianColorOptions(card) {
    if (card._guardianColorOptions) return card._guardianColorOptions;

    card._guardianColorOptions = Array.prototype.slice.call(card.querySelectorAll('[data-color-option]')).map(function(node) {
      return {
        label: node.dataset.colorLabel,
        value: node.dataset.colorValue,
        handle: node.dataset.colorHandle,
        variantId: node.dataset.colorVariantId,
        selected: node.dataset.colorSelected === 'true',
        available: node.dataset.colorAvailable !== 'false'
      };
    }).filter(function(option) {
      return option.variantId && option.available;
    });

    return card._guardianColorOptions;
  }

  function getGuardianDefaultColor(card) {
    var colors = getGuardianColorOptions(card);
    return colors.find(function(option) { return option.selected; }) || colors[0];
  }

  function ensureGuardianColorSelections(card, quantity) {
    var colors = getGuardianColorOptions(card);
    if (!colors.length) return [];

    var fallback = getGuardianDefaultColor(card).value;
    var availableValues = colors.map(function(option) { return option.value; });
    var selections = card._guardianColorSelections || [];

    while (selections.length < quantity) selections.push(fallback);
    if (selections.length > quantity) selections = selections.slice(0, quantity);

    selections = selections.map(function(value) {
      return availableValues.indexOf(value) === -1 ? fallback : value;
    });

    card._guardianColorSelections = selections;
    return selections;
  }

  function formatGuardianLabel(template, replacements) {
    var label = template || '';
    Object.keys(replacements).forEach(function(key) {
      label = label.split(key).join(replacements[key]);
    });
    return label;
  }

  function renderGuardianSwatchButtons(card, colors, activeValue, unitIndex) {
    return colors.map(function(color) {
      var active = color.value === activeValue;
      var swatchLabel = formatGuardianLabel(card.dataset.swatchLabelTemplate, { __color__: color.label });
      return '<button type="button" class="quick-checkout__swatch quick-checkout__swatch--' + escapeGuardianText(color.handle) + (active ? ' quick-checkout__swatch--active' : '') + '" data-color-unit-index="' + unitIndex + '" data-color-value="' + escapeGuardianText(color.value) + '" aria-label="' + escapeGuardianText(swatchLabel) + '" aria-pressed="' + (active ? 'true' : 'false') + '"><span class="visually-hidden">' + escapeGuardianText(color.label) + '</span></button>';
    }).join('');
  }

  function renderGuardianColorPickers(card, quantity) {
    var colors = getGuardianColorOptions(card);
    if (!colors.length) return [];

    var selections = ensureGuardianColorSelections(card, quantity);
    var units = card.querySelector('[data-color-units]');

    if (units) {
      units.innerHTML = '<div><p class="quick-checkout__color-heading">' + escapeGuardianText(card.dataset.colorHeading) + '</p><p class="quick-checkout__color-copy">' + escapeGuardianText(card.dataset.colorCopy) + '</p></div>' + selections.map(function(value, index) {
        var color = colors.find(function(option) { return option.value === value; }) || colors[0];
        var rowTitle = formatGuardianLabel(card.dataset.colorRowTitleTemplate, { __index__: String(index + 1) });
        return '<div class="quick-checkout__color-row"><div><p class="quick-checkout__color-row-title">' + escapeGuardianText(rowTitle) + '</p><p class="quick-checkout__color-row-choice">' + escapeGuardianText(color.label) + '</p></div><div class="quick-checkout__swatches">' + renderGuardianSwatchButtons(card, colors, value, index) + '</div></div>';
      }).join('');
    }

    return selections;
  }

  function buildGuardianCartPermalink(card, cartUrl, fallbackVariantId, quantity, selections) {
    var colors = getGuardianColorOptions(card);
    if (!colors.length || !selections.length) {
      return fallbackVariantId ? cartUrl + '/' + fallbackVariantId + ':' + quantity : cartUrl;
    }

    var colorByValue = colors.reduce(function(result, color) {
      result[color.value] = color;
      return result;
    }, {});

    var counts = selections.reduce(function(result, value) {
      var color = colorByValue[value];
      if (!color) return result;
      result[color.variantId] = (result[color.variantId] || 0) + 1;
      return result;
    }, {});

    var parts = Object.keys(counts).map(function(variantId) {
      return variantId + ':' + counts[variantId];
    });

    return parts.length ? cartUrl + '/' + parts.join(',') : cartUrl;
  }

  function parseGuardianQuantity(value) {
    var quantity = parseInt(value, 10);
    if (!quantity || quantity < 1) return 1;
    return Math.min(20, quantity);
  }

  function resetGuardianQuickCheckout(card) {
    card.dataset.quantity = '1';
    card.dataset.lastQuantity = '1';
    card._guardianColorSelections = null;
    updateGuardianQuickCheckout(card);
  }

  function resetGuardianQuickCheckoutCards() {
    document.querySelectorAll('[data-quick-checkout-card]').forEach(resetGuardianQuickCheckout);
  }

  function updateGuardianQuickCheckout(card) {
    var unitPrice = parseInt(card.dataset.unitPrice || '0', 10);
    var variantId = card.dataset.variantId;
    var cartUrl = card.dataset.cartUrl || '/cart';
    var moneyFormat = card.dataset.moneyFormat || ('{' + '{amount}' + '}');
    var quantity = parseGuardianQuantity(card.dataset.quantity || '1');

    card.dataset.quantity = String(quantity);
    card.dataset.lastQuantity = String(quantity);

    var subtotal = unitPrice * quantity;
    var discountRate = quantity >= 2 ? 0.1 : 0;
    var discount = Math.round(subtotal * discountRate);
    var total = subtotal - discount;

    var quantityValue = card.querySelector('[data-quantity-value]');
    var decrease = card.querySelector('[data-quantity-decrease]');
    var increase = card.querySelector('[data-quantity-increase]');
    var lineLabel = card.querySelector('[data-line-label]');
    var linePrice = card.querySelector('[data-line-price]');
    var discountLine = card.querySelector('[data-discount-line]');
    var discountLabel = card.querySelector('[data-discount-label]');
    var discountPrice = card.querySelector('[data-discount-price]');
    var totalPrice = card.querySelector('[data-total-price]');
    var colorSelections = renderGuardianColorPickers(card, quantity);
    var shippingStatus = card.querySelector('[data-shipping-status]');
    var shippingIcon = card.querySelector('[data-shipping-icon]');
    var shippingText = card.querySelector('[data-shipping-text]');
    var checkoutLink = card.querySelector('[data-checkout-link]');

    if (quantityValue) quantityValue.value = quantity;
    if (decrease) decrease.disabled = quantity <= 1;
    if (increase) increase.disabled = quantity >= 20;
    if (lineLabel) lineLabel.textContent = formatGuardianLabel(card.dataset.lineLabelTemplate, { __quantity__: String(quantity) });
    if (linePrice) linePrice.textContent = formatGuardianMoney(subtotal, moneyFormat);
    if (totalPrice) totalPrice.textContent = formatGuardianMoney(total, moneyFormat);

    if (discountLine) {
      discountLine.hidden = discount === 0;
      if (discountLabel) discountLabel.textContent = card.dataset.discountLineLabel;
      if (discountPrice) discountPrice.textContent = '−' + formatGuardianMoney(discount, moneyFormat);
    }

    if (shippingStatus) {
      var hasQuantityDiscount = quantity >= 2;
      shippingStatus.classList.toggle('quick-checkout__shipping-status--included', hasQuantityDiscount);
      shippingStatus.classList.toggle('quick-checkout__shipping-status--needed', !hasQuantityDiscount);
      shippingStatus.disabled = hasQuantityDiscount;
      if (shippingIcon) shippingIcon.textContent = hasQuantityDiscount ? '✓' : '+';
      if (shippingText) shippingText.textContent = hasQuantityDiscount ? card.dataset.promoIncluded : card.dataset.promoUpsell;
    }

    if (checkoutLink) {
      checkoutLink.href = buildGuardianCartPermalink(card, cartUrl, variantId, quantity, colorSelections);
    }
  }

  document.addEventListener('click', function(event) {
    var card = event.target.closest('[data-quick-checkout-card]');
    if (!card) return;

    if (event.target.closest('[data-quantity-increase]')) {
      card.dataset.quantity = String(parseGuardianQuantity(card.dataset.quantity || '1') + 1);
      updateGuardianQuickCheckout(card);
    }

    if (event.target.closest('[data-quantity-decrease]')) {
      card.dataset.quantity = String(parseGuardianQuantity(card.dataset.quantity || '1') - 1);
      updateGuardianQuickCheckout(card);
    }

    var colorChoice = event.target.closest('[data-color-unit-index][data-color-value]');
    if (colorChoice) {
      var selections = ensureGuardianColorSelections(card, parseGuardianQuantity(card.dataset.quantity || '1'));
      selections[parseInt(colorChoice.dataset.colorUnitIndex, 10)] = colorChoice.dataset.colorValue;
      card._guardianColorSelections = selections;
      updateGuardianQuickCheckout(card);
    }

    if (event.target.closest('[data-shipping-status]')) {
      var quantity = parseGuardianQuantity(card.dataset.quantity || '1');
      if (quantity < 2) {
        card.dataset.quantity = '2';
        updateGuardianQuickCheckout(card);
      }
    }

  });

  document.addEventListener('input', function(event) {
    var quantityInput = event.target.closest('[data-quick-checkout-card] [data-quantity-value]');
    if (!quantityInput) return;

    quantityInput.value = quantityInput.value.replace(/[^0-9]/g, '');
  });

  document.addEventListener('change', function(event) {
    var quantityInput = event.target.closest('[data-quick-checkout-card] [data-quantity-value]');
    if (!quantityInput) return;

    var card = quantityInput.closest('[data-quick-checkout-card]');
    if (quantityInput.value == '') {
      quantityInput.value = card.dataset.lastQuantity || card.dataset.quantity || '1';
      return;
    }

    card.dataset.quantity = String(parseGuardianQuantity(quantityInput.value));
    updateGuardianQuickCheckout(card);
  });

  document.querySelectorAll('[data-quick-checkout-card]').forEach(updateGuardianQuickCheckout);
  window.addEventListener('pageshow', function() {
    resetGuardianQuickCheckoutCards();
    requestAnimationFrame(resetGuardianQuickCheckoutCards);
  });
  } catch(e) { console.error(e); }
})();

})();
